
/**
 * @file cardboard/jQMSetup.js
 * @desc quick module to set up jQuery Mobile's defaults. NOTE: this
 * is what actually loads up jQuery Mobile. All the disabling of
 * jQuery mobile's routing has to happen before that machinery is
 * used, and they recommend that you do it on the mobileinit event,
 * but we have real trouble getting requireJS to guarantee that we can
 * set that event handler up before jquery Mobile loads. I was able to
 * do it using the nested require statement you see below, but that
 * caused jQuery Mobile to *start* loading dead last, which is
 * awful. So for now, we take control by having this module as the
 * only one with a dependency on JQM, and we forget about the event
 * handler and just DO it as soon as we can. We'll see if that causes
 * problems or not, but it seems to work.
 * @author Geoffrey Pursell
 */

define('cardboard/jQMSetup',["require", "jquery"// , "jqMobile"
	   ],
function (require, $ /*jqMobile*/) {

	/**
	 * @module cardboard/jQMSetup
	 * @desc quick module to set up jQuery Mobile's defaults
	 */

	console.log("MODULE: cardboard/jQMSetup");

	// disable lots of stuff that's slow or gets in the way
	function disableJQMRouting() {
		// documentation for these options is here:
		// http://api.jquerymobile.com/global-config/

		$.mobile.ajaxEnabled = false;
        $.mobile.hashListeningEnabled = false;
        $.mobile.pushStateEnabled = false;
        $.mobile.linkBindingEnabled = true; //-- works properly with jqm 1.1.1 rc1

        $.mobile.defaultDialogTransition = "none";
        $.mobile.defaultPageTransition = "none";
        $.mobile.page.prototype.options.degradeInputs.date = true;
        $.mobile.page.prototype.options.domCache = false;

        $.mobile.ignoreContentEnabled = false;
	}

	$(document).on("mobileinit", disableJQMRouting);

	require(["jqMobile"], function () {
		console.log("loaded jquery mobile");
	});

	// disableJQMRouting();

	return {
		/** function to finish constructing the module at runtime, after
		 * the DOM has loaded */
		domReadyInit: function () {
			// $.mobile.pageContainer = $("#pageContainer");
			// $.mobile.firstPage = $("#page_workspace");
		}
	};
});

